import Vue from 'vue';
import $ from 'jquery';
import BootstrapVue from 'bootstrap-vue';
//import NavbarPlugin from 'bootstrap-vue';
import App from './App.vue';
import router from './router';
import store from './store';

import u from './util'
import * as log from 'loglevel'

// /* in components where bootstrap-vue used:
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// The command to install vue-navigation-bar 4.1.0 is... //
// npm i vue-navigation-bar@4.1.0 //

import vueVimeoPlayer from 'vue-vimeo-player'

Vue.use(vueVimeoPlayer)

Vue.use(BootstrapVue);
//Vue.use(NavbarPlugin);

Vue.config.productionTip = false;

router.beforeEach(function(to, from, next){
    //console.log("to:",to,from);
    var URLdomain = window.location.protocol + "//" + window.location.host;
    transmitMeta(to, from, next, URLdomain)
})

var transmitMeta = function (to, from, next, URLdomain) {		  
    var URL = URLdomain + "/pageLoad";
    var URLdone = URLdomain + "/pageLoaded";
    var doc = store.state.Meta[to.name];
    log.debug("transmit doc meta",doc)
    var ogType = "article";
    if (to.name === 'start' || to.name === 'home' || to.name === 'main'){
	ogType = "website";
	$("head").attr("prefix","og: http://ogp.me/ns# fb: http://ogp.me/ns/fb# website: http://ogp.me/ns/website#");
    } else {
	$("head").attr("prefix","og: http://ogp.me/ns# fb: http://ogp.me/ns/fb# article: http://ogp.me/ns/article#");
    }
    var Error = null;
    if (to.name === "NotFound"){
	Error = true;
    }
    //console.log("before",doc)
    //change meta info
    /*
    document.title = doc.title;
    $("meta[name='description']").attr("content",doc.description);
    $("meta[property='og:type']").attr("content",ogType);
    $("meta[property='og:image']").attr("content",doc.image);
    $("meta[property='twitter:image:src']").attr("content",doc.image);
    $("meta[property='og:title']").attr("content",doc.title);
    $("meta[property='twitter:title']").attr("content",doc.title);
    $("meta[property='og:description']").attr("content",doc.description);
    $("meta[property='twitter:description']").attr("content",doc.description);
    $("meta[property='og:url']").attr("content",URLdomain + "/#" + to.fullPath);
    */
    next()
    /*
    if (!u.localP()){
	ajax(URL,function(data){
	    //console.log("load",data);
	    //next(
	    
	    ajax(URLdone,function(data2){
		//console.log("loaded",data2);
	    })
	    //);
	},null,null,{URI: to.fullPath, error: Error});
    }*/
};

var ajaxError = function (URL,
			jqXHR,
			textStatus,
			errorThrown,
			data,
			callback) {
    console.error("ERROR lobe.Ajax", {jqXHR: jqXHR,
				    textStatus: textStatus,
				    errorThrown: errorThrown,
				    url: URL,
				    data: JSON.stringify(data),
				    callback: JSON.stringify(callback)});
    alert("Internal error - please request help from graphMetrix admin (or see developer console)." +
	  "\nError: " + errorThrown +
	  "\nStatus: " + textStatus +
	  "\nURL: " + URL);
}


var ajax = function (URL, callback, Type, dataType, data, cache, Asyn) {
    var Async;
    if (!Type) {
        Type = "POST";
    }
    if (!cache){
	cache = false;
    }
    if (!dataType) {
	dataType = "json";
    }
    if (typeof (Asyn) === "boolean") {
        Async = Asyn;
    } else {
	Async = true;
    }
    $.ajaxSetup({
        async: Async
    });
    $.ajax({
        type: Type,
        url: URL,
        data: data,
        async: Async,
        cache: cache,
        success: function (Data) {
	    callback(Data);
        },
        error: function(jqXHR, textStatus, errorThrown){
	    ajaxError(URL, jqXHR, textStatus, errorThrown, data,callback);
	},
        dataType: dataType
    });
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#content');
